module.exports = __webpack_public_path__ + "images/phs-white.png";


//////////////////
// WEBPACK FOOTER
// ./assets/phs-white.png
// module id = 1
// module chunks = 0